module.exports = __webpack_public_path__ + "static/media/add category.34762930.svg";